import { render, staticRenderFns } from "./editCube9.vue?vue&type=template&id=4b6934ea&scoped=true&"
import script from "./editCube9.vue?vue&type=script&lang=js&"
export * from "./editCube9.vue?vue&type=script&lang=js&"
import style0 from "./editCube9.vue?vue&type=style&index=0&id=4b6934ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6934ea",
  null
  
)

export default component.exports